import {storage} from '../../utilities'
import { ref, uploadBytesResumable } from 'firebase/storage'

export function baseStore(path) {
  return function (file) {
    const r = ref(storage, path + file.name)
    return uploadBytesResumable(r, file)
  }
}
